<template lang="html">
<div class="" style="text-align:center">
    <p>Loading saved map view...</p>
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
</div>
</template>

<script>
import gql from 'graphql-tag';
import { apolloClient } from '@/apollo/apollo';
import * as actions from '@/constants/actions';

export default {
    async created() {
        // the short url key is the pathname without the leading "/"
        // ex: "saved/surface-water-quality-jeJmTp"
        const urlPath = window.location.pathname.replace('/', '');

        try {
            // resolve short url
            const { data } = await apolloClient.query({
                query: gql`query expandShortUrl($key: String!) {
                    getUrlShortener(key: $key)
                }`,
                variables: { key: urlPath },
            });

            const urlData = data.getUrlShortener;

            // if the query is successful, but no saved url is found
            if (urlData === null) {
                throw new Error('Error expanding saved URL');
            }

            // set map zoom, if specified
            if (urlData.mapZoom) {
                this.$store.dispatch(actions.SET_LOADSTATE_MAP_ZOOM, urlData.mapZoom);
            }

            // map center
            if (urlData.mapCenter) {
                this.$store.dispatch(actions.SET_LOADSTATE_MAP_CENTER, urlData.mapCenter);
            }

            // filter settings
            if (urlData.filterSettings && Object.keys(urlData.filterSettings).length) {
                this.$store.dispatch(actions.SET_LOADSTATE_MAP_FILTER_SETTINGS, urlData.filterSettings);
            }

            // redirect to page
            this.$router.push(urlData.pageRoute);
        } catch (e) {
            // if there was an error decoding the short url, redirect to home
            this.$router.push('/');
        }
    },
};
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/ShortUrlHandler.vue